<template>
  <div>
    <!-- 工具栏 -->
    <div style="display: flex; justify-content: space-between">
      <!--       搜索-->
      <div>
        <el-input
          style="width: 180px; margin-right: 10px"
          prefix-icon="el-icon-search"
          v-model="condition"
          size="small"
          @keydown.enter.native="onSearch"
          @clear="onSearch"
          placeholder="请输入信息进行搜索..."
          clearable
        >
        </el-input>
        <el-radio v-model="expired" :label="0">未过期</el-radio>
        <el-radio v-model="expired" :label="1">已过期</el-radio>
        <el-radio v-model="expired" :label="2">所有</el-radio>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="onSearch"
          size="small"
          >搜索</el-button
        >
      </div>
      <!-- 右边工具 -->
      <div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="showAddView"
          size="small"
          v-if="qx"
          >上传证书</el-button
        >
        <!-- 新增单位 -->
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="showAddUnitView"
          size="small"
          style="margin-left: 10px"
          v-if="qx"
          >新增单位</el-button
        >
        <el-button
          type="success"
          @click="downloadSelectedRows"
          style="margin-left: 10px"
          size="small"
        >
          <i class="fa fa-level-down" aria-hidden="true"></i>
          导出选中数据
        </el-button>
        <!--        <el-button type="primary" size="small" @click="toggleSelection()" style="margin-left: 10px">
          <i class="el-icon-close"></i>
          取消选择
        </el-button>-->
      </div>
    </div>
    <!--抽屉-->
    <el-drawer
      :title="
        currentEmployee ? `${currentEmployee.userName}的证书` : '员工姓名'
      "
      :visible.sync="table"
      direction="rtl"
      size="50%"
    >
      <el-table
        :data="gridData"
        :row-class-name="({ row }) => expireCellStyle(row)"
      >
        <el-table-column
          prop="userName"
          label="员工姓名"
          align="center"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="certiTypes"
          label="证书类别"
          align="center"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="certiUnits"
          label="认证单位"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <span>{{ getUnitNames(scope.row.certiUnits, Units) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="certiChinese"
          label="证书中文"
          align="center"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="certiShort"
          label="证书缩写"
          align="center"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="certiEndTime"
          label="证书到期时间"
          align="center"
          width="180"
        class-name="cell-two-line">
          <template slot-scope="scope">
            <div>
              {{ scope.row.certiEndTime }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="neverEnd"
          label="是否永久"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.neverEnd === 1 ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="haveEntity"
          label="是否有原件"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.haveEntity === 1 ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="inCompany"
          label="是否在公司"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.inCompany === 1 ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="description"
          label="描述信息"
          align="center"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="更新时间"
          align="center"
          width="180"
        >
        </el-table-column>
      </el-table>
    </el-drawer>
    <!-- 表格 -->
    <div style="margin-top: 20px">
      <el-table
        :data="costData"
        class="el-table"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        border
        :row-class-name="({ row }) => expireCellStyle(row)"
        size="small"
        fit
        height="calc(100vh - 250px)"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        style="width: 100%"
      >
        <!-- 多选框 -->
        <el-table-column type="selection" width="55">
        </el-table-column>

        <el-table-column
          prop="userName"
          label="员工姓名"
          align="center"
          width="130"
        >
          <template slot="header" slot-scope="scope">
            <el-select
              v-model="userNameFilter"
              filterable
              clearable
              placeholder="筛选员工"
              size="mini"
              style="width: 100%"
              @change="onSearch"
            >
              <el-option
                v-for="item in useroption"
                :key="item.id"
                :label="item.trueName"
                :value="item.trueName"
              />
            </el-select>
          </template>
          <template slot-scope="scope">
            <el-button type="text" @click="showCertificates(scope.row)">
              {{ scope.row.userName }}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column align="center" min-width="190" show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-select
              v-model="inputobjCerti.certiTypes"
              placeholder="请选择证书类别"
              size="mini"
              style="width: 100%; margin-right: 10px"
              clearable
              filterable
              multiple
              @change="onSearch"
            >
              <el-option
                v-for="item in Type1"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            {{ scope.row.certiTypes }}
          </template>
        </el-table-column>
        <el-table-column align="center" min-width="190" show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-select
              v-model="companyList"
              placeholder="请选择单位名称"
              size="mini"
              style="width: 100%; margin-right: 10px"
              clearable
              filterable
              @change="onSearch"
            >
              <el-option
                v-for="item in Units"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <span>{{ getUnitNames(scope.row.certiUnits, Units) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fileTrueName"
          label="文件名称"
          align="center"
          min-width="150"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="showCertificatesfileTrueName(scope.row)"
              >{{ getOriginFileName(scope.row.fileName) }}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="certiChinese"
          label="证书中文"
          align="center"
          min-width="140"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="certiShort"
          label="证书缩写"
          align="center"
          min-width="80"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="certiEndTime"
          label="证书到期时间"
          align="center"
          min-width="130"
        
        :formatter="dateTimeTwoLine"
        class-name="cell-two-line"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.neverEnd === 1 ? "长期" : scope.row.certiEndTime }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="haveEntity"
          label="是否有原件"
          align="center"
          min-width="60"
        >
          <template slot-scope="scope">
            {{ scope.row.haveEntity === 1 ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="inCompany"
          label="是否在公司"
          align="center"
          min-width="60"
        >
          <template slot-scope="scope">
            {{ scope.row.inCompany === 1 ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="description"
          label="描述信息"
          align="center"
          width="100"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          min-width="260"
        >
          <template slot-scope="scope">
            <!-- <el-button type="primary" size="mini" style="padding: 2px">编辑</el-button> -->
            <el-button
              type="primary"
              size="mini"
              @click="showEditView(scope.row)"
              v-if="qx"
              :disabled="kaiguan(scope.row.createTime)"
              >编辑</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="downloadCertificate(scope.row)"
              v-if="downloadBtn"
              :loading="
                downloadLoadingId === (scope.row.fileName || scope.row.id)
              "
              >{{
                downloadLoadingId === (scope.row.fileName || scope.row.id)
                  ? "下载中"
                  : "下载"
              }}</el-button
            >
            <el-button
              type="danger"
              @click="deleteRecord(scope.row)"
              size="mini"
              v-if="qx"
              :disabled="kaiguan(scope.row.createTime)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div
        style="
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-top: 5px;
        "
      >
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          :page-sizes="[200, 400, 500, 600, 800, 1000]"
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="total"
          :current-page="page"
          :page-size="limit">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="预览" :visible.sync="dialogTableVisible"       :close-on-click-modal="false"
      :close-on-press-escape="false"
>
      <div v-if="selectedFile && fileType === 'image'" class="preview-image-wrap">
        <div v-if="imageLoading" class="preview-loading preview-loading-mask">
          <div class="preview-loading-spinner"></div>
          <span>图片加载中...</span>
        </div>
        <div v-else-if="imageLoadError" class="preview-loading preview-loading-mask preview-error">
          <i class="el-icon-picture-outline"></i>
          <span>图片加载失败</span>
        </div>
        <img
          :key="selectedFile.fileName"
          :src="generatePreviewUrl(selectedFile.fileName)"
          class="preview-image"
          alt="证书预览"
          @load="onImageLoad"
          @error="onImageError"
        />
      </div>
      <div v-else-if="selectedFile && fileType === 'pdf'">
        <VueOfficeReview
        :fileUrl="generatePreviewUrl(selectedFile.fileName)"
        />
        <!-- <vue-pdf-no-sss
          :src="generatePreviewUrl(selectedFile.fileName)"
          style="width: 100%; max-height: 400vh"
          fit="contain"
        ></vue-pdf-no-sss> -->
      </div>
    </el-dialog>

    <!-- 弹出框  dialogVisible:是否弹出 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="50%"       :close-on-click-modal="false"
      :close-on-press-escape="false"
>
      <div>
        <!-- 增加一层 el-form表单，可以数据校验 -->
        <el-form
          ref="inputForm"
          :model="inputObj"
          :rules="rules"
          label-width="140px"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="员工姓名" prop="userName">
                <el-select
                  v-model="inputObj.userName"
                  placeholder="请选择"
                  size="mini"
                  :disabled="xmShow"
                  filterable
                  style="width: 250px"
                  @change="getPhone($event)"
                >
                  <el-option
                    v-for="item in useroption"
                    :key="item.id"
                    :label="item.trueName"
                    :value="item.trueName"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发证单位" prop="certiUnits">
                <el-select
                  v-model="inputObj.certiUnits"
                  multiple
                  placeholder="请选择"
                  size="mini"
                  :disabled="xmShow"
                  filterable
                  style="width: 250px"
                  clearable
                >
                  <el-option
                    v-for="item in Units"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="证书中文" prop="certiChinese">
                <el-input
                  size="mini"
                  prefix-icon="el-icon-edit"
                  style="width: 250px"
                  v-model="inputObj.certiChinese"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电话号码" prop="phone">
                <el-input
                  size="mini"
                  prefix-icon="el-icon-edit"
                  style="width: 250px"
                  v-model="inputObj.phone"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="证书类别" prop="certiTypes">
                <el-select
                  v-model="inputObj.certiTypes"
                  placeholder="请选择"
                  size="mini"
                  :disabled="xmShow"
                  filterable
                  style="width: 250px"
                  clearable
                >
                  <el-option
                    v-for="item in Type1"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="证书缩写" prop="certiShort">
                <el-input
                  size="mini"
                  prefix-icon="el-icon-edit"
                  style="width: 250px"
                  v-model="inputObj.certiShort"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否有原件" prop="haveEntity">
                <el-radio-group
                  v-model="inputObj.haveEntity"
                  class="aligned-rate"
                >
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                v-if="inputObj.haveEntity === 1"
                label="证书是否在公司"
                prop="inCompany"
              >
                <el-radio-group
                  v-model="inputObj.inCompany"
                  class="certificate-radio-group"
                >
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否永久">
                <el-radio-group
                  v-model="inputObj.neverEnd"
                  class="aligned-rate"
                >
                  <el-radio :label="0" @change="handleNeverEndChange"
                    >否</el-radio
                  >
                  <el-radio :label="1" @change="handleNeverEndChange"
                    >是</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item
                label="证书有效期"
                prop="certiEndTime"
                :rules="dateRules"
              >
                <el-date-picker
                  size="mini"
                  v-model="inputObj.certiEndTime"
                  style="width: 250px"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  :picker-options="{ disabledDate: disabledDate }"
                  :disabled="inputObj.neverEnd === 1"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="描述信息" prop="description">
                <el-input
                  type="text"
                  size="mini"
                  prefix-icon="el-icon-edit"
                  style="width: 770px"
                  v-model="inputObj.description"
                  placeholder="请输入描述信息"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="选择文件" prop="fileTrueName">
                <el-upload
                  ref="upload"
                  :on-remove="handleRemove"
                  :on-change="fileChange"
                  :before-upload="beforeAvatarUpload"
                  :before-remove="beforeRemove"
                  multiple
                  :file-list="upload.fileList"
                  action=""
                  :auto-upload="false"
                >
                  <el-button size="small" type="primary" icon="el-icon-upload2"
                    >点击上传</el-button
                  >
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--        <el-button @click="doSave">保存</el-button>-->
        <el-button @click="doChance">取 消</el-button>
        <el-button type="primary" @click="doAddRecord">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 新增单位弹窗 -->
    <el-dialog
      title="新增单位"
      :visible.sync="addUnitDialogVisible"
      width="400px"
      @close="newUnitName = ''"
            :close-on-click-modal="false"
      :close-on-press-escape="false"

    >
      <el-form @submit.native.prevent>
        <el-form-item label="单位名称" :label-width="'80px'">
          <el-input
            v-model="newUnitName"
            placeholder="请输入单位名称"
            maxlength="50"
            @keyup.enter.native="confirmAddUnit"
            autofocus
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addUnitDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAddUnit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import table2excel from "js-table2excel/src";
import VueOfficeReview from "@/components/VueOfficeReview";
export default {
  name: "CertiOpera",
  data() {
    return {
      headerMapping: {
        userName: "用户姓名",
        fileTrueName: "文件名称",
        certiTypes: "证书类型",
        certiUnits: "发证单位",
        certiChinese: "证书中文",
        certiShort: "证书缩写",
        certiEndTime: "证书到期时间",
        neverEnd: "证书有效期是否为永久",
        haveEntity: "是否有实体",
        inCompany: "是否在公司",
        description: "描述信息",
      },
      dateRules: [], // 用于存储证书有效期字段的规则
      userId: null,
      currentEmployee: null,
      certificatesData: [], // 替换为实际的证书信息数据
      certiChinese: null, //数据保存在本地
      table: false, // 初始化table属性
      userNameFilter: "", // 新增：员工姓名筛选
      addUnitDialogVisible: false, // 控制弹窗显示
      newUnitName: "", // 新单位名称
      tableData: [],
      gridData: [], // 最初为空
      dialogTableVisible: false,
      fileTrueNameData: [],
      previewFileUrl: "",
      selectedFile: null,
      fileType: "",
      imageLoading: false, // 图片预览 loading 状态
      imageLoadError: false, // 图片预览加载失败
      companyList: [], //公司列表
      qx: false,
      downloadBtn: false,
      title: "",
      xmShow: false,
      costData: [], // 存放查询结果
      loading: false,
      total: 0,
      page: 1,
      limit: 200,
      condition: "",
      expired: 2,
      dialogVisible: false,
      dialogData: false,
      certiTtypeOptionsType: null,
      multipleSelection: [],
      selectedRows: {}, //选择框
      Type1: [], //证书类别下拉框
      Units: [],
      inputobjCerti: {
        certiTypes: [],
      },
      trueName: "",
      useroption: [], //员工下拉框
      Type: [], //证书大类下拉框
      certiTtypeOptions: [], // 证书小类 下拉框
      certiTypeOptions: [],
      inputObj: {
        userName: null,
        certiUnits: [],
        certiTypes: [],
        phone: null,
        certiTypeId: null,
        certiTtypeId: null,
        certiChinese: "",
        certiShort: "",
        certiEndTime: "",
        description: "",
        id: null,
        projectId: null,
        neverEnd: 0,
        haveEntity: 0,
        inCompany: 0,
        fileTrueName: null,
      },
      downloadLoadingId: null,
      filelist: [],
      upload: {
        // 是否禁用上传
        isUploading: false,
        // 设置上传的请求头部
        // headers: {Authorization: "Bearer " + getToken()},
        // 上传的地址
        url: "",
        // 上传的文件列表
        fileList: [],
        originFileObj: [],
      },
      rules: {
        userName: [
          {
            required: true,
            message: "请输入员工姓名",
            trigger: "blur",
          },
        ],
        certiUnits: [
          {
            required: true,
            message: "请输入发证单位",
            trigger: "blur",
          },
        ],
        certiTypes: [
          {
            required: true,
            message: "请选择证书类别",
            trigger: "blur",
          },
        ],
        certiChinese: [
          {
            required: true,
            message: "请输入证书中文",
            trigger: "blur",
          },
        ],
        certiShort: [
          {
            required: true,
            message: "请输入证书缩写",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入电话号码",
            trigger: "blur",
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入有效的手机号码",
            trigger: "blur",
          },
        ],
        certiEndTime: [
          {
            required: true,
            message: "请选择证书有效期",
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value && this.inputObj.neverEnd == 0) {
                callback(new Error("请选择证书有效期"));
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },

  watch: {
    "inputObj.certiEndTime": {
      handler(val) {
        if (!val) this.inputObj.certiEndTime = "";
      },
    },
  },
  components: {
    VueOfficeReview,
  },
  mounted() {
    this.quanxian();
    this.initCost();
    this.initDim();
    this.handleNeverEndChange();
  },

  methods: {
    // 获取原始文件名，去掉时间戳部分
    getOriginFileName(fileName) {
      if (!fileName) return "";
      // 去除前面的时间戳和下划线
      return fileName.replace(/^\d{8,}_/, "");
    },
    // 获取员工姓名列表对应的电话号码
    getPhone(row) {
      const user = this.useroption.find((item) => item.trueName === row);
      if (user) {
        this.inputObj.phone = user.phone;
      } else {
        this.inputObj.phone = "";
      }
    },
    // 根据发证单位代码获取对应的单位名称
    getUnitNames(certiUnits, Units) {
      if (!certiUnits) return "";
      // 如果是对象数组 [{certiUnitCode, certiUnitName}]
      if (
        Array.isArray(certiUnits) &&
        certiUnits.length &&
        typeof certiUnits[0] === "object"
      ) {
        return certiUnits
          .map((u) => u.certiUnitName || u.name || u.code)
          .join(", ");
      }
      // 如果是字符串
      if (typeof certiUnits === "string") {
        return certiUnits
          .split(/[ ,，;]/)
          .filter(Boolean)
          .map((code) => {
            const unit = Units.find((item) => item.code === code);
            return unit ? unit.name : code;
          })
          .join(", ");
      }
      // 如果是 code 数组
      if (Array.isArray(certiUnits)) {
        return certiUnits
          .map((code) => {
            const unit = Units.find((item) => item.code === code);
            return unit ? unit.name : code;
          })
          .join(", ");
      }
      return "";
    },
    // 显示新增单位弹窗
    showAddUnitView() {
      this.addUnitDialogVisible = true;
      this.newUnitName = "";
    },
    // 确认新增单位
    confirmAddUnit() {
      const name = this.newUnitName && this.newUnitName.trim();
      if (!name) {
        this.$message.warning("请输入单位名称");
        return;
      }
      // 检查是否已存在
      const exists = this.Units.some((u) => u.name === name);
      if (exists) {
        this.$message.warning("该单位已存在");
        return;
      }
      // 生成唯一 code，可用时间戳
      this.postRequest("/certificate/addcertiunit", {
        name: name,
      }).then((res) => {
        if (res.code === 200) {
          this.addUnitDialogVisible = false;
          //清空sessionStorage里面Units数组，重新加载
          sessionStorage.removeItem("Units");
          this.initDim(); // 重新加载单位列表
        } else {
          this.$message.error(res.message || "单位添加失败");
        }
      });
    },
    // 预览，传入文件名称。由后缀名判断文件类型
    showCertificatesfileTrueName(row) {
      this.selectedFile = row;
      this.dialogTableVisible = true;
      const fileExtension = row.fileName.split(".").pop().toLowerCase();
      this.fileType = this.getFileType(fileExtension);
      // 打开预览时强制重置图片加载状态
      this.imageLoading = true;
      this.imageLoadError = false;
    },
    // 图片加载完成
    onImageLoad() {
      this.imageLoading = false;
      this.imageLoadError = false;
    },
    // 图片加载失败
    onImageError() {
      this.imageLoading = false;
      this.imageLoadError = true;
    },
    // 提取文件类型判断逻辑到单独的方法
    getFileType(fileExtension) {
      if (fileExtension === "pdf") {
        return "pdf";
      } else if (["jpg", "jpeg", "png", "gif"].includes(fileExtension)) {
        return "image";
      }
      return "unknown";
    },
    generatePreviewUrl(fileName) {
      return `https://oa.yunqingtech.com:443/files/certi/${encodeURIComponent(
        fileName
      )}`; // 拼接url
    },

    // 员工全部证书信息
    showCertificates(row) {
      this.currentEmployee = row;
      this.table = true;
      this.loading = true;
      this.fetchData("/certificate/usercertilist", {
        userId: row.userId,
        page: 1,
        limit: 200,
      }).then((resp) => {
        this.loading = false;
        if (resp) {
          this.gridData = resp.data;
        }
      });
    },

    toggleSelection(rows) {
      rows
        ? rows.forEach((row) =>
            this.$refs.multipleTable.toggleRowSelection(row)
          )
        : this.$refs.multipleTable.clearSelection();
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    async downloadSelectedRows() {
      const columns = [
        "userName",
        "certiTypes",
        "certiUnits",
        "certiChinese",
        "certiEndTime",
        "neverEnd",
        "haveEntity",
        "inCompany",
        "description",
      ];
      const columnConfig = columns.map((key) => ({
        title: this.getColumnTitle(key),
        key,
        type: "text",
        width: 100,
        height: 100,
      }));
      const rowsToExport = this.costData
        .filter((row, index) => this.multipleSelection[index])
        .map((ele) => ({
          ...ele,
          certiUnits: this.getUnitNames(ele.certiUnits, this.Units), // 转中文
          haveEntity: ele.haveEntity === "1" ? "是" : "否",
          inCompany: ele.inCompany === "1" ? "是" : "否",
        }));

      const excelName = "证书列表";
      table2excel(columnConfig, rowsToExport, excelName);
    },
    // 提取列标题映射逻辑到单独的方法
    getColumnTitle(key) {
      const mapping = {
        userName: "员工姓名",
        certiTypes: "证书类别",
        certiUnits: "发证单位",
        certiChinese: "证书中文",
        certiEndTime: "证书到期时间",
        neverEnd: "证书是否永久",
        haveEntity: "证书是否有实体",
        inCompany: "证书是否在公司",
        description: "描述",
      };
      return mapping[key];
    },

    // 证书到期时间高亮提醒
    expireCellStyle(row) {
      if (row.neverEnd == 0 && row.certiEndTime) {
        const currentTime = new Date().getTime();
        const certEndTime = new Date(row.certiEndTime).getTime();
        const sixtyDays = 60 * 24 * 60 * 60 * 1000; // 60天毫秒数
        // 证书即将到期（60天内）
        if (
          certEndTime - currentTime <= sixtyDays &&
          certEndTime - currentTime > 0
        )
          return "warn";
        // 证书已过期
        if (currentTime > certEndTime) return "expireds";
      }
      return "";
    },

    // 文件下载函数：直接用证书静态文件地址下载
    // 1) 优先 fetch 转 blob + a[download], 解决服务器未返回 attachment 头时浏览器直接打开图片的问题
    // 2) fetch 失败时降级为 <a target=_self download>, 大多数浏览器仍可下载
    async downloadCertificate(row) {
      const id = row.fileName || row.id; // 优先用 fileName，或用唯一 id
      this.downloadLoadingId = id; // 开始 loading（仅当前行）
      const url = `https://oa.yunqingtech.com:443/files/certi/${encodeURIComponent(
        row.fileName
      )}`;
      const fileName = this.getOriginFileName(row.fileName) || "certificate";
      try {
        // 关键：不带任何自定义请求头,避免跨域 CORS 失败
        const response = await fetch(url, { method: "GET" });
        if (!response.ok) {
          throw new Error("HTTP " + response.status);
        }
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = fileName;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        // 释放 blob URL
        setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
        this.$message.success("开始下载");
      } catch (error) {
        console.error("fetch 下载失败，降级为直接下载：", error);
        // 降级：直接打开下载链接（部分浏览器会直接下载图片，部分会打开）
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.target = "_self";
        a.rel = "noopener";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        this.$message.warning(
          "当前下载方式可能直接打开图片，请使用浏览器「另存为」保存"
        );
      } finally {
        this.downloadLoadingId = null; // 结束 loading
      }
    },

    handleNeverEndChange() {
      this.dateRules =
        this.inputObj.neverEnd === 0 ? this.rules.certiEndTime : [];
    },

    handleCertiTypeChange(val) {
      this.certiTypeOptions = this.Type;
      this.inputObj.certiTypeId = this.inputObj.certiType;
      this.inputObj.certiTtype = null;
      this.fetchData(
        `/dim/get_child_dim_table?type=certificate_type&parentCode=${this.inputObj.certiType}`
      )
        .then((resp) => {
          if (resp) {
            this.certiTtypeOptions = resp.result;
          }
        })
        .catch((error) => {
          console.error("获取证书小类选项失败：", error);
        });
    },

    moneyNumber(val) {
      return val.toLocaleString("zh-Hans-CN", {
        style: "currency",
        currency: "CNY",
      });
    },

    towNumber(val) {
      return val.toFixed(6);
    },

    quanxian() {
      const userRoleId = window.sessionStorage.getItem("userRoleId");
      if (userRoleId) {
        const fullAccessRoles = ["1", "29", "37", "44", "46"];
        const downloadAccessRoles = [
          "1",
          "2",
          "31",
          "28",
          "29",
          "44",
          "37",
          "46",
        ];
        this.qx = fullAccessRoles.includes(userRoleId);
        this.downloadBtn = downloadAccessRoles.includes(userRoleId);
      }
    },

    kaiguan(sj) {
      return false;
    },

    doChance() {
      this.dialogVisible = false;
    },

    showEditView(data) {
      this.title = "编辑证书";
      this.dialogVisible = true;
      this.xmShow = false;
      this.upload.fileList = [{ name: data.fileTrueName }];
      this.inputObj = { ...data };
      this.processDataIds(data, ["certiTypes", "certiUnits"]);
    },
    // 提取处理数据 ID 分割的逻辑到单独的方法
    processDataIds(data, keys) {
      keys.forEach((key) => {
        const obj = JSON.parse(JSON.stringify(data));
        this.inputObj[key] = obj[`${key}Id`].split(" ");
        this.inputObj[key].pop();
      });
    },

    deleteRecord(data) {
      this.$confirm(
        `此操作将永久删除 ${data.userName}的${data.certiChinese}，是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.postRequests(`/certificate/delcerti?id=${data.id}`).then(
            (resp) => {
              if (resp) {
                this.initCost();
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    doAddRecord() {
      this.$refs["inputForm"].validate((valid) => {
        if (valid) {
          const formData = this.createFormData(this.inputObj);
          this.upload.fileList.forEach((file) => {
            if (file.raw) {
              formData.append("file", file.raw, file.name);
            }
          });
          const url = this.inputObj.id
            ? "/certificate/updatecerti"
            : "/certificate/addcerti";
          this.postRequest(url, formData).then((resp) => {
            if (resp) {
              this.dialogVisible = false;
              this.initCost();
            }
          });
          this.resetForm();
        }
      });
    },
    // 提取创建 FormData 的逻辑到单独的方法
    createFormData(data) {
      const formData = new window.FormData();
      Object.entries(data).forEach(([key, value]) => {
        if (key === "id" && value) {
          formData.append(key, value);
        } else if (key !== "id") {
          formData.append(key, value);
        }
      });
      return formData;
    },
    // 提取重置表单的逻辑到单独的方法
    resetForm() {
      this.upload.fileList = [];
      this.picList = [];
      this.dataFileList = [];
      this.dialogVisible = false;
      this.inputobjCerti.certiTypes = null;
      this.condition = null;
      this.initCost();
    },

    initDim() {
      const getData = async (key, requestUrl, parseFunc = JSON.parse) => {
        if (!window.sessionStorage.getItem(key)) {
          const resp =
            key === "useroption"
              ? await this.getRequest(requestUrl)
              : await this.postRequest(requestUrl);
          if (resp) {
            this[key] = key === "useroption" ? resp.data : resp.result;
            window.sessionStorage.setItem(key, JSON.stringify(this[key]));
          }
        } else {
          this[key] = parseFunc(window.sessionStorage.getItem(key));
        }
      };

      const requests = [
        {
          key: "Type1",
          url: "/dim/get_two_level_dim_table_char?type=certificate_type",
        },
        { key: "Units", url: "/dim/dim_table_char/company" },
        { key: "useroption", url: "/user/queryAllUser" },
      ];

      requests.forEach(({ key, url }) => getData(key, url));
    },

    currentChange(currentPage) {
      this.page = currentPage;
      this.initCost();
    },

    sizeChange(limit) {
      this.page = 1; // 改每页条数：回到第 1 页
      this.limit = limit;
      this.initCost();
    },

    showAddView() {
      this.title = "上传证书";
      this.dialogVisible = true;
      this.xmShow = false;
      this.inputObj = {
        userName: null,
        certiUnits: null,
        certiTypes: [],
        certiTypeId: null,
        certiTtypeId: null,
        certiChinese: "",
        certiShort: "",
        certiEndTime: null,
        description: "",
        projectId: null,
        phone: null,
        neverEnd: 0,
        haveEntity: 0,
        inCompany: 0,
      };
      this.upload.fileList = [];
    },

    // 搜索/筛选入口：先回到第 1 页再查（避免在第 N 页搜索时结果不足一页而显示空白）
    onSearch() {
      this.page = 1;
      this.initCost();
    },

    initCost() {
      const searchData = {
        page: this.page,
        limit: this.limit,
        typeList: this.inputobjCerti.certiTypes
          ? this.inputobjCerti.certiTypes.toString()
          : "",
        condition: this.condition ? this.condition : this.userNameFilter,
        expired: this.expired,
        companyList: this.companyList,
      };
      console.log(this.companyList,'searchData');
      this.fetchData("/certificate/certilist", searchData);
    },
    // 提取通用的请求逻辑到单独的方法
    async fetchData(url, data = {}) {
      this.loading = true;
      try {
        const resp = await this.getRequests(url, data);
        if (resp) {
          this.costData = resp.data;
          this.total = resp.total;
        }
        return resp;
      } finally {
        this.loading = false;
      }
    },

    disabledDate(time) {
      return (
        this.inputObj.neverEnd &&
        time.getTime() >= new Date("9999-12-31").getTime()
      );
    },

    beforeAvatarUpload(file) {
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
      if (this.upload.fileList.length === 0) {
        this.showEditView(this.inputObj);
        return true;
      }
      if (
        this.upload.fileList[1] &&
        this.upload.fileList[1].hasOwnProperty("raw")
      ) {
        return true;
      }
      console.error("无效的文件对象");
      return true;
    },

    handleRemove(file, fileList) {
      this.picList = this.picList.filter((item) => item.key !== file.uid);
    },

    fileChange(file, fileList) {
      setTimeout(() => {
        if (fileList.length > 1) {
          this.$message.warning("文件数量只能上传1个！");
          this.upload.fileList = [fileList[1]];
          return;
        }
        this.upload.fileList = [...fileList];
      }, 1);
    },

    beforeRemove(file, fileList) {
      const originalFileList = [...fileList];
      return this.$confirm(`确定移除 ${file.name}？`)
        .then(() => {
          const indexToRemove = fileList.findIndex(
            (item) => item.uid === file.uid
          );
          this.upload.fileList.splice(indexToRemove, 1);
        })
        .catch(() => {
          this.upload.fileList = originalFileList;
        });
    },
    // ... existing code ...
  },
};
</script>

<style>
.aligned-rate {
  margin-top: 5px; /* 调整这个值以控制下移的距离 */
}
.certificate-radio-group {
  margin-top: 5px;
}
.el-table .warn {
  background-color: #f3de25ff;
}
.el-table .expireds {
  background-color: #f7b7bcff !important;
}
/* 
 1.员工姓名列的筛选 *
 2.证书类别修改，统一分成7类，等售前整理数据 *
 3.单位名称修改成有就选，无就输入保存数据字典
 4.快过期（60天）变成黄色背景，已过期变成红色背景 *
 5.证书到期时间，非永久显示具体时间，永久显示长期 *
 6.创建时间，修改时间，不显示 *
 7.选完员工姓名带出电话号码 *
 8.附件下载报错 *
*/

/* 预览图片 loading / 错误状态 */
.preview-image-wrap {
  position: relative;
  min-height: 240px;
}
.preview-image {
  display: block;
  width: 100%;
  max-height: 400vh;
  object-fit: contain;
}
.preview-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 200px;
  color: #909399;
  font-size: 13px;
}
.preview-loading-mask {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.85);
  z-index: 2;
}
.preview-loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid rgba(64, 158, 255, 0.2);
  border-top-color: #409eff;
  border-radius: 50%;
  animation: preview-loading-rotate 0.8s linear infinite;
}
@keyframes preview-loading-rotate {
  to {
    transform: rotate(360deg);
  }
}
.preview-error {
  min-height: 200px;
}
.preview-error i {
  font-size: 36px;
  color: #c0c4cc;
}
</style>
